import { Action, CustomTagType, DockType, ErrorCodes, OperationType, Position, WindowType } from "puzzle";
import ClaimTaskDialog from "../../components/SupplierView/ClaimTaskDialog/ClaimTaskDialog";

export const claim_job_phase: Action = [{
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionData.submissionName}',
        submissionId: '{submissionData.submissionId}',
        taskId: '{submissionData.taskId}'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'get',
    template: {
      bind: {
        url: `"/jobPhase/" + {taskId} + "/claim"`
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: '{responseData.hasBudgetableTask}',
  conditionOperations: [{
    name: 'job_phase_view_offer',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'openClaimDialogSupplier',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const openClaimDialogSupplier: Action = [{
  data: {
    template: {
      responseData: {
        bind: {
          data: '{responseData}',
          phase: '{submissionData.phaseName}'
        }
      },
      isClaim: true,
    }
  },
  type: OperationType.data
}, {
  className: 'lg claim-task',
  children: [{
    render: ClaimTaskDialog,
    propArgs: ['submissionData', 'responseData', 'isClaim']
  }],
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }],
  title: 'claimTask.title',
  type: OperationType.dialog
}];

/**
 * Supplier Reserve action flow
 */
export const reserve_job_phase: Action = [{
  name: 'claim_job_phase',
  type: OperationType.action
}];

export const unclaim_job_phase: Action = [{
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionData.submissionName}',
        submissionId: '{submissionData.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: `"/jobPhase/" + {selectedSubmissions[0].taskId} + "/unclaim"`
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  data: {
    template: {
      responseData: {
        bind: {
          data: '{responseData}',
          phase: '{selectedSubmissions[0].phaseName}'
        }
      },
      isClaim: false,
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  className: 'lg claim-task',
  children: [{
    render: ClaimTaskDialog,
    propArgs: ['submissionData', 'responseData', 'isClaim'],
  }],
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }],
  title: 'unclaimTask.title',
  type: OperationType.dialog
}]

export const unclaimTask: Action = [{
  moduleName: 'ClaimTaskDialog',
  name: 'getData',
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  data: {
    method: 'post',
    template: {
      bind: {
        url: `"/jobPhase/" + {selectedSubmissions[0].submissionId} + "/unclaim"`,
        params: '{params}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        url: `"/jobPhase/" + {selectedSubmissions[0].submissionId} + "/unclaim"`
      },
      afterPingFinishAction: 'afterUnclaimCompletion',
      method: 'post'
    }
  },
  type: OperationType.data
}, {
  name: 'pingingRequest',
  type: OperationType.action
}]

export const claimSupplier: Action = [{
  data: {
    template: {
      bind: {
        submissionId: '{submissionData.submissionId}',
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'ClaimTaskDialog',
  name: 'getData',
  mappingName: 'params',
  type: OperationType.addOperationData
}, {
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: `"/jobPhase/" + {submissionId} + "/claim"`,
        params: '{params}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        url: `"/jobPhase/" + {submissionId} + "/claim"`
      },
      additionalDataSync: 'syncDataForClaimAndOpen',
      afterPingFinishAction: 'afterClaimCompletion',
      method: 'post'
    }
  },
  type: OperationType.data
}, {
  name: 'pingingRequest',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
},]

export const afterUnclaimCompletion: Action = [{
  moduleName: 'ClaimTaskDialog',
  name: 'getNotificationData',
  mappingName: 'notificationData',
  type: OperationType.addOperationData
}, {
  moduleName: 'ToastNotifications',
  name: 'createClaimNotifications',
  args: ['notificationData']
}, {
  name: 'refreshMainGrid',
  type: OperationType.action
}, {
  name: 'closeClaimSupplierDialog',
  type: OperationType.action
}, {
  name: 'closeDrawer',
  type: OperationType.action
}];

export const afterClaimCompletion: Action = [{
  moduleName: 'ClaimTaskDialog',
  name: 'getNotificationData',
  mappingName: 'notificationData',
  type: OperationType.addOperationData
}, {
  moduleName: 'ToastNotifications',
  name: 'createClaimNotifications',
  args: ['notificationData']
}, {
  condition: '{notificationData.reservePhaseLength}', //Adding second notification in case we have reserve task(s)
  conditionOperations: [{
    moduleName: 'ToastNotifications',
    name: 'createSupplierClaimAndReserveNotifications',
    args: ['notificationData']
  }],
  type: OperationType.conditional
}, {
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  condition: '{claimAndOpen} === "openInEditor"',
  conditionOperations: [{
    moduleName: 'ActionExecutor',
    name: 'executeOpenTask',
    args: ['submissionData', 'editor']
  }],
  elseOperations: [{
    condition: '{claimAndOpen} === "downloadGLP"',
    conditionOperations: [{
      data: {
        template: {
          params: {
            downloadType: 'GLP'
          }
        }
      },
      type: OperationType.data
    }, {
      name: 'downloadFiles',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const closeClaimSupplierDialog: Action = [{
  windowType: WindowType.dialog,
  type: OperationType.closeWindow
}];

export const syncDataForClaimAndOpen = [{
  condition: '{claimAndOpen} && {submissionData}',
  conditionOperations: [{
    items: ['claimAndOpen', 'submissionData', 'editor'],
    type: OperationType.syncDispatchersDataItem
  }],
  type: OperationType.conditional
}];
